<template>
  <el-dropdown @command="handleCommand" @visible-change="handleVisibleChange">
    <span class="avatar-dropdown">
      <!-- <el-avatar class="user-avatar" :src="avatar" /> -->
      <div class="user-name">
        <vab-icon icon="font-size" />
        <vab-icon
          class="vab-dropdown"
          :class="{ 'vab-dropdown-active': active }"
          icon="arrow-down-s-line"
        />
      </div>
    </span>
    <template #dropdown>
      <el-dropdown-menu>
        <el-dropdown-item command="small">
          <div class="flex_start flex_center_align">
            <vab-icon icon="font-size" />
            <div class="font" :class="{ active: fontChange == 'small' }">
              小
            </div>
          </div>
        </el-dropdown-item>
        <el-dropdown-item command="middle">
          <div class="flex_start flex_center_align">
            <vab-icon icon="font-size" />
            <div class="font" :class="{ active: fontChange == 'middle' }">
              中
            </div>
          </div>
        </el-dropdown-item>
        <el-dropdown-item command="big">
          <div class="flex_start flex_center_align">
            <vab-icon icon="font-size" />
            <div class="font" :class="{ active: fontChange == 'big' }">大</div>
          </div>
        </el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>

<script>
  import { translateTitle } from '@/utils/i18n'
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'VabFont',
    data() {
      return {
        active: false,
        fontChange: '',
      }
    },
    computed: {
      ...mapGetters({
        avatar: 'user/avatar',
        username: 'user/username',
      }),
    },
    mounted() {
      let fontSize = window.localStorage.getItem('fontSize') || ''
      let className = window.localStorage.getItem('className') || ''
      let fontChange = window.localStorage.getItem('fontChange') || ''
      if (fontSize) {
        document
          .getElementsByTagName('body')[0]
          .style.setProperty('--font-size', fontSize)
      }
      if (className) {
        document.getElementsByTagName('body')[0].className = className
      }
      if (fontChange) {
        this.fontChange = fontChange
      }
    },
    methods: {
      translateTitle,
      ...mapActions({
        _logout: 'user/logout',
      }),
      handleCommand(command) {
        let fontSize = null
        let className = ''
        let fontChange = ''
        switch (command) {
          case 'small':
            fontSize = 12 + 'px'
            className = 'vab-theme-blue-white'
            fontChange = 'small'
            break
          case 'middle':
            fontSize = 14 + 'px'
            className = 'vab-theme-blue-white middle_font_main'
            fontChange = 'middle'
            break
          case 'big':
            fontSize = 16 + 'px'
            className = 'vab-theme-blue-white big_font_main'
            fontChange = 'big'
            break
        }
        document
          .getElementsByTagName('body')[0]
          .style.setProperty('--font-size', fontSize)
        document.getElementsByTagName('body')[0].className = className
        window.localStorage.setItem('className', className)
        window.localStorage.setItem('fontSize', fontSize)
        window.localStorage.setItem('fontChange', fontChange)
        this.fontChange = fontChange
      },
      handleVisibleChange(val) {
        this.active = val
      },
    },
  }
</script>

<style lang="scss" scoped>
  .avatar-dropdown {
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
    justify-items: center;

    .user-avatar {
      width: 40px;
      height: 40px;
      margin-left: 15px;
      cursor: pointer;
      border-radius: 50%;
    }

    .user-name {
      position: relative;
      display: flex;
      align-content: center;
      align-items: center;
      height: 40px;
      margin-left: 6px;
      line-height: 40px;
      cursor: pointer;

      [class*='ri-'] {
        margin-left: 0 !important;
      }
    }
  }
  .font {
    padding-left: 10px;
  }
  .active {
    color: $base-color-blue;
  }
</style>
